<template>
  <swiper
    :navigation="true"
    :modules="modules"
    class="slider slider_colors"
    :slidesPerView="'auto'"
    :spaceBetween="8"
  >
    <swiper-slide v-for="(color, index) in getColors" :key="index">
      <ColorButton :src="color.picture" :name="color.name" :value="index" />
    </swiper-slide>
  </swiper>
</template>

<script>
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue";

import { Navigation } from "swiper/modules";

import ColorButton from "../ColorButton/ColorButton.vue";
export default {
  name: "SliderColors",
  components: {
    Swiper,
    SwiperSlide,
    ColorButton,
  },
  inject: ["getColors"],
  setup() {
    return {
      modules: [Navigation],
    };
  },
};
</script>
